import React, {
  FC, useEffect, useRef, useState,
} from 'react'
import cn from 'classnames'
import style from '@src/components/Message/Message.module.scss'
import { ReactComponent as Arrow } from '@src/assets/msg-arrow.svg'
import { updateStatusMsg } from '@src/store/ducks/user/thunks'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '@src/store/store'
import { selectUserUnreadMessages } from '@src/store/ducks/user/selectors'
import { setUserUnreadMessages } from '@src/store/ducks/user/reducer'

type MessageProps = {
    elem: number,
    date: string,
    title: string,
    description: string,
    className?: string,
    isRead: boolean,
}

const MessageAccordion: FC<MessageProps> = ({
  elem, date, title, description,
  className, isRead,
}) => {
  const [activeKey, setActiveKey] = useState<number | null>(null)
  const [unreadBorder, setUnreadBorder] = useState<string>('')

  const dispatch = useDispatch<AppDispatch>()
  const countUnreadMessages = useSelector(selectUserUnreadMessages)
  const [moreText, setMoreText] = useState<boolean>(false)
  const descriptionRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (descriptionRef.current) {
      setMoreText(descriptionRef.current.offsetHeight > 15)
    }
    setUnreadBorder(isRead ? '' : style.unreadBorder)
  }, [isRead])
  const handleClick = (keyEl: number) => {
    if (!isRead) {
      setUnreadBorder('')
    }
    if (unreadBorder) {
      dispatch(setUserUnreadMessages(countUnreadMessages - 1))
    }
    setActiveKey((prevKey) => (prevKey === keyEl ? null : keyEl))
    dispatch(updateStatusMsg(keyEl))
  }

  return (
    <button
      type="button"
      className={cn(style.messageAccordionContainer, activeKey === elem && style.activeWrapper,
        className, unreadBorder, moreText && style.moreTextStyle)}
      onClick={() => handleClick(elem)}
    >
      <div className={style.date}>{date}</div>
      <div className={cn(style.messageAccordionTextContainer)}>
        <div className={style.title}>{title}</div>
        <div
          ref={descriptionRef}
          className={cn(style.description, {
            [style.activeDescription]: activeKey === elem,
            [style.inactiveDescription]: activeKey !== elem,
          })}
        >
          {' '}
          {description}
        </div>
      </div>
      {moreText && <Arrow className={style.messageAccordionContainer_svg} />}
    </button>
  )
}

export default MessageAccordion
